// @flow
import React from "react";
import {RideAcceptedTopContainer, RideAcceptedTopImg, RideAcceptedTopLabel} from "./RideAcceptedTopStyle";
import { images } from '../../../../../config';
import {RideAcceptedContentContainer} from "../RideAcceptedStyle";

type OwnProps = {
    pickupAddress: string,
}

const RideAcceptedTop = (props: OwnProps) => {
    return (
        <RideAcceptedTopContainer>
            <RideAcceptedContentContainer>
                <RideAcceptedTopImg src={images.waiting_for_pickup_walking_man} alt={`walking man`}/>
            </RideAcceptedContentContainer>
            <RideAcceptedContentContainer>
                <RideAcceptedTopLabel>
                    {props.pickupAddress}
                </RideAcceptedTopLabel>
            </RideAcceptedContentContainer>
        </RideAcceptedTopContainer>
    );
};
export default RideAcceptedTop;



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAcceptedTop/RideAcceptedTop.js